import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { sceneList, messageSort } from './request';
export default {
  data() {
    return {
      data: [],
      columns: [{
        dataIndex: 'messageSort',
        slots: {
          title: '消息类别'
        },
        width: 200,
        align: 'center',
        customRender: (value, row, index) => {
          const obj = {
            children: this.$t(value),
            attrs: {}
          };
          if (this.rowSpanObj[index]) {
            obj.attrs.rowSpan = this.rowSpanObj[index];
          } else if (this.colSpanIndex.indexOf(index) > -1) {
            obj.attrs.colSpan = 0;
          }
          return obj;
        }
      }, {
        dataIndex: 'pushScenario',
        slots: {
          title: '推送场景'
        },
        width: 200,
        align: 'center',
        customRender: (text, record) => {
          return this.$t(text) || '-';
        }
      }, {
        dataIndex: 'action',
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        width: 200,
        align: 'center'
      }],
      rowSpanObj: {},
      colSpanIndex: []
    };
  },
  created() {
    this.getSceneList();
  },
  methods: {
    getSceneList() {
      sceneList({}).then(res => {
        let data = [];
        let index = 0;
        let rowSpanObj = {};
        let colSpanIndex = [];
        if (res) {
          Object.keys(res).forEach(key => {
            let itemLength = res[key].length;
            if (itemLength > 1) {
              rowSpanObj[index] = itemLength;
            }
            for (let i = index + 1; i < index + itemLength; i++) {
              // 收集需要合并的列
              colSpanIndex.push(i);
            }
            index = index + itemLength;
            res[key].forEach(item => {
              item.messageSort = messageSort[key];
              data.push(item);
            });
          });
          this.data = data;
          this.rowSpanObj = rowSpanObj;
          this.colSpanIndex = colSpanIndex;
        }
      });
    },
    editScene(record) {
      this.$router.push({
        name: 'editScene',
        params: {
          id: record.id
        }
      });
    }
  }
};